<template>
  <b2b-overlay v-model="isActive" :transition="transition" class="b2b-aside" role="aside">
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>

    <aside class="b2b-aside__wrap" :style="styles">
      <div class="b2b-aside__title">
        <slot name="title" />
      </div>

      <div class="b2b-aside__content">
        <slot />
      </div>

      <div class="b2b-aside__actions">
        <slot name="actions" />
      </div>
    </aside>
  </b2b-overlay>
</template>

<script>
import ActivableMixin from '../../mixins/base/activable-mixin';

import B2bOverlay from './b2b-overlay.vue';

export default {
  name: 'b2b-aside',

  components: {
    B2bOverlay,
  },

  mixins: [
    ActivableMixin(),
  ],

  props: {
    right: Boolean,
  },

  data() {
    return {
      transition: null,
      styles: {
        left: null,
        right: null,
      },
    };
  },

  watch: {
    right: {
      immediate: true,
      handler(isRight) {
        this.styles.right = isRight ? 0 : null;
        this.styles.left = isRight ? null : 0;
        this.transition = isRight ? 'b2b-aside__transition-right' : 'b2b-aside__transition-left';
      },
    },
  },
};
</script>

<style lang="scss">
.b2b-aside {
  overflow: hidden;

  display: inline-block;
  white-space: nowrap;

  &__wrap {
    top: 0;
    bottom: 0;
    width: 320px;
    max-width: calc(100% - 64px);

    z-index: 100;
    position: absolute;

    display: flex;
    flex-direction: column;

    background-color: $colorBackgroundCard;
    box-shadow:
      0 8px 10px -5px rgba(0, 0, 0, 0.2),
      0 16px 24px 2px rgba(0, 0, 0, 0.14),
      0 6px 30px 5px rgba(0, 0, 0, 0.12);
  }

  &__title {
    flex: 0;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;

    overflow-x: hidden;
    overflow-y: auto;
  }

  &__transition {
    &-right {
      &-enter-active {
        animation: b2b-aside-transition-right 0.3s;
      }

      &-leave-active {
        animation: b2b-aside-transition-right 0.3s reverse;
      }
    }

    &-left {
      &-enter-active {
        animation: b2b-aside-transition-left 0.3s;
      }

      &-leave-active {
        animation: b2b-aside-transition-left 0.3s reverse;
      }
    }
  }
}

@keyframes b2b-aside-transition-right {
  0% {
    left: 100%
  }
  100% {
    left: 0;
  }
}

@keyframes b2b-aside-transition-left {
  0% {
    left: -100%
  }
  100% {
    right: 0;
  }
}
</style>
